import { formatDate as formatDateTz, formatDateTime as formatDateTimeTz } from './dateUtils';
import localeConfig from '../config/locale.config';

export const formatDate = (date) => formatDateTz(date);

export const formatDateTime = (date) => formatDateTimeTz(date);

export const formatNumber = (num) => {
    return new Intl.NumberFormat(localeConfig.intlLocale || 'en-NZ').format(num);
};

export const formatPercentage = (value, total) => {
    if (total === 0) return 0;
    return Math.round((value / total) * 100);
};

export const getStatusColor = (status) => {
    const statusColors = {
        pending: 'yellow',
        active: 'blue',
        completed: 'green',
        rejected: 'red',
        expired: 'gray',
    };
    return statusColors[status] || 'gray';
};

export const debounce = (func, wait) => {
    let timeout;
    const executedFunction = function(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    
    // Add cancel method to clear the timeout
    executedFunction.cancel = () => {
        clearTimeout(timeout);
    };
    
    return executedFunction;
};
